var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown"},_vm._l((_vm.dropdownItems),function(dropdown,index){return _c('div',{key:index,staticClass:"dropdown-list"},[_c('p',{on:{"click":function($event){return _vm.actClicked(dropdown.title)}}},[_vm._v(_vm._s(dropdown.title))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }